import { addParameterToURL } from "@/shared/ui";
import type { PersonalLoanRequest, PersonalLoanResponseItem } from "../types";

const generateUtmTerm = () => {
	const formattedDate = new Date().toISOString().replace(/\D/g, "").slice(2, 12);
	const randomString = Math.random().toString(36).slice(2, 6);

	return `${formattedDate}${randomString}`;
};

export const convertMbhData = (
	_request: PersonalLoanRequest,
	response: PersonalLoanResponseItem,
): PersonalLoanResponseItem => {
	if (!response.marketing?.newTargetUrl) {
		return response;
	}

	return {
		...response,
		marketing: {
			...response.marketing,
			newTargetUrl: addParameterToURL(response.marketing.newTargetUrl, {
				utm_term: generateUtmTerm(),
			}),
		},
	};
};
